/* eslint-disable react/jsx-props-no-spreading */
import { FC, ComponentProps } from 'react';
import { Controller } from 'react-hook-form';
import { Box, Sizes, Typography, useThemeValue } from '@altermaind/web/ui';
import { convertSizeToNumber } from '@/_shared/helpers';
import { WrappedInput } from '../WrappedInput';
import { RangeWrapper, StyledRangeInput } from './styles';

type Props = {
  minLabel: string;
  maxLabel: string;
  values: (string | number)[];
} & ComponentProps<typeof WrappedInput>;

export const WrappedRangeInput: FC<Props> = ({
  minLabel,
  maxLabel,
  values,
  name,
  control,
  ...props
}) => {
  const circleSize: keyof Sizes = 'm';
  const sliderHeight: keyof Sizes = 'xs';
  const gapS = convertSizeToNumber(`${useThemeValue('sizes', 's')}`) || 24;

  const snapToNearest = (valueStr: string): string => {
    const num = Number(valueStr);
    if (Number.isNaN(num) || values.length === 0) return valueStr;
    const nearest = values.reduce((prev, curr) =>
      Math.abs(Number(curr) - num) < Math.abs(Number(prev) - num) ? curr : prev,
    );
    return String(nearest);
  };

  return (
    <Box>
      <Box mb='xxs' display='flex' justifyContent='space-between' style={{ gap: gapS }}>
        <Typography variant='p3/light' maxWidth='50%'>
          {minLabel}
        </Typography>
        <Typography variant='p3/light' maxWidth='50%' textAlign='right'>
          {maxLabel}
        </Typography>
      </Box>
      <RangeWrapper px='xxs' sliderHeight={sliderHeight} circleSize={circleSize}>
        <Controller
          control={control}
          name={name}
          defaultValue={props.defaultValue}
          render={() => (
            <StyledRangeInput
              sliderHeight={sliderHeight} // same of RangeWrapper
              circleSize={circleSize} // same of RangeWrapper
              // @ts-ignore
              control={control}
              name={name}
              {...props}
              manipulator={snapToNearest}
              type='range'
              min={values[0] || 0}
              max={values?.length ? values[values.length - 1] : 100}
              list='values'
            />
          )}
        />
      </RangeWrapper>
      <datalist id='values'>
        {values.map(value => <option key={value} value={value} label={`${value}`} />) || null}
      </datalist>
    </Box>
  );
};
